<template>
  <div>
    <head-nav></head-nav>
    <div class="form-pass">
      <img src="../../img/mission-logo.png" style="max-width:300px; margin-left: -11px">
      <br>
      <br>
      <br>
      <span style=" font-family: 'lemon_milkregular';padding-top:15px;padding-bottom:15px">
        Your email has been verified
      </span>
      <br>
      <br>
      <br>
      <a class="message" @click="goToLogin" style="font-family:berleno; cursor: pointer;">Back to
        website</a>
    </div>

    <info></info>

  </div>
</template>

<script>

import headNav from '../../components/navBar.vue';
import info from '../../components/info.vue'

export default {
  components: {
    headNav,
    info
  },
  methods:{
    goToLogin() { this.$router.push('/login'); }
}
}
</script>

<style>
.form-pass {
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  max-width: 580px;
  max-height: 580px;
  margin: 20px auto 40px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form-pass button {
  font-family: 'lemon_milkregular';
  text-transform: uppercase;
  outline: 0;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #FFFFFF;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}

.form-pass .message {
  margin: 5px 0 0;
  color: #212529;
  font-size: 15px;
  text-decoration: none;
}
</style>